import { IContact } from 'clickNgo/entities/contact'

export const filterBySearchQuery = (contacts: IContact[], searchQuery: string) => {
  return contacts.filter((contact) => {
    const searchQueryLower = searchQuery.toLowerCase()
    return (
      contact.contactId?.toLowerCase().includes(searchQueryLower) ||
      contact.learnerId?.toLowerCase().includes(searchQueryLower) ||
      contact.firstName?.toLowerCase().includes(searchQueryLower) ||
      contact.lastName?.toLowerCase().includes(searchQueryLower) ||
      contact.email?.toLowerCase().includes(searchQueryLower) ||
      contact.hpRoles.join(',').toLowerCase().includes(searchQueryLower) ||
      contact.userStatus?.toLowerCase().includes(searchQueryLower) ||
      contact.workPhoneNumber?.toLowerCase().includes(searchQueryLower) ||
      contact.mobilePhoneNumber?.toLowerCase().includes(searchQueryLower) ||
      contact.locationId?.toLowerCase().includes(searchQueryLower) ||
      contact.partnerId?.toLowerCase().includes(searchQueryLower) ||
      contact.communicationName?.toLowerCase().includes(searchQueryLower) ||
      contact.city?.toLowerCase().includes(searchQueryLower)
    )
  })
}
